import React, { createContext } from 'react';

const BooksContext = createContext({});

export { BooksContext };
